import { useState, Fragment } from "react";
// import { loginUser, useAuth } from "../../lib/auth";
import { useAuth } from "../../lib/auth";
// import { BrowserRouter as Router, Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ButtonComponent from "../ButtonComponent";
import { Input } from "../Input";
import { COLORS } from "../../lib/colors";
import * as HTTPServices from "../../api/HTTPServices";
import * as Toast from "../../lib/toast";
import { ToastContainer } from "react-toastify";
// import * as DataServices from "../../api/DataServices";
import { ReactComponent as ReturnBtn } from "../../assets/images/return-button.svg";
import { ReactComponent as UnitedKingdom } from "../../assets/images/flags/united-kingdom.svg";
import { ReactComponent as Spain } from "../../assets/images/flags/spain.svg";
import { ReactComponent as Turkey } from "../../assets/images/flags/turkey.svg";
import { ReactComponent as Iran } from "../../assets/images/flags/iran.svg";

import classes from "./Login.module.scss";
import "../../i18n";

export default function LoginForm() {
  const { t, i18n } = useTranslation();
  let auth = useAuth();
  const [step, setStep] = useState(0);
  const [userType, setUserType] = useState(2);
  const [username, setUsername] = useState("");
  const [code, setCode] = useState();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpBtnLoading, setotpBtnLoading] = useState(false);
  const [passwordType, setPasswordType] = useState("static");

  const changeLanguage = (lng) => {
    let previusLanguage = localStorage.getItem("language");

    if (lng === "fa" && previusLanguage !== "fa") {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
      window.location.reload();
    } else if (previusLanguage === "fa" && lng !== "fa") {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
      window.location.reload();
    } else {
      i18n.changeLanguage(lng);
      localStorage.setItem("language", lng);
    }
  };

  const handleFirstStep = (e) => {
    setStep(1);
  };

  const handleLogin = (e) => {
    if (passwordType === "static") {
      setLoading(true);
      setError("");

      auth.confirmPassword(username, code, userType);
      setTimeout(() => {
        setLoading(false);
      }, 2000);
      return;
    }
    // e.preventDefault();
    setLoading(true);
    setError("");
    auth.confirmLogin(username, code, userType);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };
  const useOtp = () => {
    setPasswordType("otp");
    setotpBtnLoading(true);
    try {
      // loginUser(username);
      let userName;
      const params = new URLSearchParams();
      //Persian Num to ENG
      const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));
      const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
      userName = p2e(username);
      userName = a2e(username);
      //END

      if (Number.isInteger(parseInt(userName))) {
        params.append("mobile", userName);
      } else {
        params.append("email", userName);
      }

      const RequestService = HTTPServices.postMethod("login_v2", params);
      RequestService.then(function (response) {
        if (response) {
          Toast.SuccessData(t("components.LoginForm.toastStep1"));
          setotpBtnLoading(false);
        } else {
          setotpBtnLoading(false);
        }
      }).catch(function (error) {});
    } catch (error) {
      setotpBtnLoading(false);
    }
  };

  // const showError = (err) => {
  //   const error = (err.response && err.response.data) || err.message;
  //   setError(error);
  // };
  return (
    <div className={classes.container}>
      <div className={classes.lngbarContainer}>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.purple}
          // width={140}
          onClick={() => changeLanguage("en")}
          icon={<UnitedKingdom width={30} height={30} />}
        >
          <span className={classes.langName}>English</span>
        </ButtonComponent>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.purple}
          // width={140}
          onClick={() => changeLanguage("es")}
          icon={<Spain width={30} height={30} />}
        >
          <span className={classes.langName}>Spanish</span>
        </ButtonComponent>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.purple}
          // width={140}
          onClick={() => changeLanguage("tr")}
          icon={<Turkey width={30} height={30} />}
        >
          <span className={classes.langName}>Turkish</span>
        </ButtonComponent>
        <ButtonComponent
          className={classes.languageBtn}
          backgroundColor={COLORS.purple}
          // width={140}
          onClick={() => changeLanguage("fa")}
          icon={<Iran width={30} height={30} />}
        >
          <span className={classes.langName}>فارسی</span>
        </ButtonComponent>
      </div>
      <main className={classes.main}>
        {step === 0 ? (
          <Fragment>
            <div className={classes.switchUserType}>
              <ButtonComponent
                backgroundColor={userType === 2 ? COLORS.yellow : ""}
                onClick={() => {
                  setUserType(2);
                }}
              >
                {t("components.LoginForm.userType.patient")}
              </ButtonComponent>
              <ButtonComponent
                backgroundColor={userType === 1 ? COLORS.yellow : ""}
                onClick={() => {
                  setUserType(1);
                }}
              >
                {t("components.LoginForm.userType.doctor")}
              </ButtonComponent>
            </div>
            <div className={classes.submitForm}>
              <h2>{t("components.LoginForm.title")}</h2>
              <p>{t("components.LoginForm.titleDescription")}</p>
              <Input
                className={classes.inputEmail}
                name="username"
                label={t("components.LoginForm.inputEmailPlacholder")}
                onChange={(e) => {
                  setUsername(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.keyCode === 13) {
                    handleFirstStep();
                  } else {
                    setUsername(e.target.value);
                  }
                }}
                value={username}
                required
                autoFocus
              />
            </div>
          </Fragment>
        ) : (
          <div className={classes.loginCodeContainer}>
            <div style={{ marginBottom: 30 }}>
              {passwordType === "otp" &&
                `A message has been sent to you Please enter the code sent to the ${username} in the field below`}
            </div>
            <Input
              className={classes.inputEmail}
              name="logincode"
              type="text"
              // label={t("components.LoginForm.inputLoginCodePlacholder")}
              label={
                passwordType === "static"
                  ? "enter your password"
                  : "enter recieved code"
              }
              onChange={(e) => {
                setCode(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.keyCode === 13) {
                  handleLogin();
                } else {
                  setCode(e.target.value);
                }
              }}
              required
              autoFocus
            />

            <ButtonComponent
              onClick={useOtp}
              className={classes.otpBtn}
              id="submit"
              type="submit"
              backgroundColor={COLORS.yellow}
              width="60%"
              disabled={username === "" || loading ? true : false}
              loading={otpBtnLoading ? true : false}
            >
              {passwordType === "static" ? "use otp login" : "send code again"}
            </ButtonComponent>
          </div>
        )}
        <div className={classes.submitBtnContainer}>
          <ButtonComponent
            onClick={step === 0 ? handleFirstStep : handleLogin}
            className={classes.submitBtn}
            id="submit"
            type="submit"
            backgroundColor={COLORS.purple}
            width="100%"
            disabled={username === "" || loading ? true : false}
            loading={loading ? true : false}
          >
            {step === 0
              ? `${t("components.LoginForm.loginBtnStep1")}`
              : `${t("components.LoginForm.loginBtnStep2")}`}
          </ButtonComponent>
        </div>
        {step === 1 && (
          <ReturnBtn
            onClick={() => {
              setStep(0);
              setPasswordType("static");
            }}
          />
        )}

        {error && <div>{error}</div>}
        {step === 0 && (
          <div className={classes.privacy}>
            <a href="https://sbm24.com/" target="_blank" rel="noreferrer">
              {t("components.LoginForm.privacy")}
            </a>
          </div>
        )}
      </main>
      <ToastContainer />
    </div>
  );
}
